import { ActivityAPIModel, OfflineTrackerAPIModel, PaginatedAPI, activityTypes } from 'src/app/models/api.model'
import { ActivityDashboardModel } from 'src/app/models/model'

export interface OfflineTrackerState {
  details: OfflineTrackerAPIModel
  summary: PaginatedAPI<OfflineTrackerAPIModel>
}

export const initialOfflineTrackerState: OfflineTrackerState = {
  details: undefined,
  summary: undefined
}
